//
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import colors from '../../colors';
import { TXT_M } from '../../constants';
import { Card, Paragraph, Title, Button, RadioButton } from 'react-native-paper';
import Touchable from '../Generic/Touchable';
import Endereco from '../../shared/entity/Endereco';
import { usePedido, useDadosPedido } from '../../redux/pedido/pedidoHooks';
import { cepMask, formatarDinheiro } from '../../shared/helper';
import IconButton from '../Generic/IconButton';
import { MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons';

type Props = {
  endereco: Endereco;
  onDelete: (endereco: Endereco) => void;
};

const ItemEndereco: React.FC<Props> = (props) => {
  const { endereco, onDelete } = props;
  const [pedido] = usePedido();
  const [setEnderecoPedido] = useDadosPedido();
  const checked = pedido.endereco && pedido.endereco.id === endereco.id;
  return (
    <Touchable onPress={() => setEnderecoPedido(endereco)} style={styles.card}>
      <Card.Content>
        <View style={styles.header}>
          <Title style={styles.title}>{endereco.apelido}</Title>
          <IconButton
            size={20}
            backgroundColor={'#fff'}
            icon={<MaterialCommunityIcons name="trash-can-outline" size={20} color="black" />}
            onPress={() => onDelete(endereco)}
          />
        </View>

        <Paragraph>{cepMask(endereco.cep)}</Paragraph>
        <Paragraph>
          {endereco.logradouro}, {endereco.numero}
        </Paragraph>
        <Paragraph>{endereco.bairro}</Paragraph>
      </Card.Content>
      <View style={{ alignSelf: 'center' }}>
        <RadioButton
          value=""
          status={checked ? 'checked' : 'unchecked'}
          onPress={() => setEnderecoPedido(endereco)}
        />
      </View>
    </Touchable>
  );
};

const styles = StyleSheet.create({
  card: {
    width: 180,
    borderWidth: 1,
    borderColor: colors.divider,
    borderRadius: 7,
    padding: 5,
    paddingTop: 10,
    paddingLeft: 0,
    paddingRight: 0,
    backgroundColor: '#fff',
    marginRight: 15
  },
  title: { flex: 1 },
  header: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }
});

export default ItemEndereco;
